import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";

// Public
import LoginScreen from "./pages/public/LoginScreen";
import NotFound from "./pages/public/NotFound";

// Admin
import { AdminDashboard } from "./layouts";
import CoomingSoon from "./pages/public/CoomingSoon";
import Formulario from "./pages/public/Formulario";
import CrearContrasena from "./pages/public/CrearContrasena";
import WeeklySchedule from "./pages/users/admin/calendar/calendarApo";
import ClientDashboard from "./layouts/clientDashboard";
import PrivateRouteAdmin from "./privateRoutes/PrivateRouteAdmin";
import AuthRoute from "./privateRoutes/AuthRoute";
import Landing from "./pages/public/Landing";
import Tienda from "./pages/public/Evento";
import Evento from "./pages/public/Evento";
import CoffeeDashboard from "./layouts/coffeeDashboard";
import Shop from "./pages/public/Shop";

const App = () => {
  return (
    <main className="bg-[#F5F4F2] ">
      <Router>
        <Routes>
          <Route path="/*" element={<CoffeeDashboard />} />
        </Routes>
      </Router>
      <ToastContainer autoClose={1500} pauseOnHover={false} />
    </main>
  );
};

export default App;
